export default __webpack_public_path__ + "static/media/29M.4104e257.jpeg";